<template>
	<div>
	    <div class="text-xs-right pb-2">
			<export-csv 
				:color="'primary'"
				:giveaway-box-id="id" 
				:file-title="title">
				<v-icon class="mr-2">get_app</v-icon>Export to CSV
			</export-csv>
	    </div>

		<v-data-table :headers="headers" :items="data.items" :hide-actions="true" :loading="loading">
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template slot="items" slot-scope="props">
				<td class="text-xs-center justify-center pa-0" width="75">{{ seqNo(props.index) }}</td>
				<td>{{ props.item.username }}</td>
				<td class="text-xs-center">{{ getProfile(props.item, 'telephone') }}</td>
				<td>
					<template v-if="props.item.consentedProfile">
						<p class="ma-0 mt-2">
							<strong>
								{{ props.item.consentedProfile.fullname }}
							</strong>
						</p>
					</template>
					<template v-if="props.item.consentedProfile">
						<p class="ma-0 mb-2">
							{{ props.item.consentedProfile.address }}
							{{ props.item.consentedProfile.province }}
							{{ props.item.consentedProfile.zipcode }}
							{{ props.item.consentedProfile.country }}
						</p>
					</template>
				</td>
				<td class="text-xs-right">{{ getProfile(props.item, 'age') }}</td>
				<td class="text-xs-center">{{ props.item.pivot.createdAt }}</td>
			</template>
			<template slot="no-data">
				<v-btn color="primary" @click="handlePageChange(1)">Reset</v-btn>
			</template>
		</v-data-table>

	    <div class="text-xs-right pt-2">
			<v-pagination v-model="data.page" :length="pages" :total-visible="6"></v-pagination>
	    </div>
	</div>
</template>

<script>
	import * as config from '@/config'
	// import exportCsv from '@/views/giveaway-box/ExportCSV.vue'
	import exportCsv from '@/views/giveaway-box/CandidatesCSV.vue'

	// The first argument is always the passed value. After that any number of arguments may be passed.
	const numberFormat = function(value) {
	  	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
	}

	export default {
		components: {
			exportCsv
		},
		props: {
			giveawayBoxId: {
				type: Number,
				default: 0
			}
		},
		data () {
			return {
	        	apiUrl: `${config.BASE_URL}/giveawayBox`,
				headers: [
					{
						text: '#',
						align: 'right',
						sortable: false,
						width: '50'
					},
					{
						text: 'Login',
						align: 'left',
						sortable: false,
					},
					{
						text: 'Tel',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Address',
						sortable: false,
					},
					{
						text: 'Age',
						align: 'right',
						sortable: false,
						width: '50'
					},
					{ 
						align: 'Submitted On', 
						align: 'center',
						sortable: false,
						width: '200'
					}
				],
				giveawayBox: null,
	            data: {
	                page: 1,
	                totalRecords: 0,
	                items: []
	            },
				pageSize: 10,
				loading: true
			}
		},
		computed: {
			id () {
				return this.giveawayBoxId
			},
			title () {
				if (this.giveawayBox) {
					return this.giveawayBox.title || ''
				} else {
					return ''
				}
				
			},
			pages () {
				if (this.pageSize == null || this.data.totalRecords == null) {
					return 0
				}
				return Math.ceil(this.data.totalRecords / this.pageSize)
			}
		},
		created () {
			this.handlePageChange(1)
		},
		methods: {
			getProfile (item, props) {
				if (typeof item.consentedProfile !== 'undefined') {
					if (item.consentedProfile) {
						return item.consentedProfile[props];
					}
				}
				return ''
			},
	    	seqNo (index) {
				return numberFormat(this.data.totalRecords - ((this.data.page - 1) * this.pageSize) - index)
	    	},
	    	handleAdd ()
	    	{
	    		this.$router.push({ path: `${config.PUBLIC_PATH}giveaway-box/new` })
	    	},
	    	handleEdit (itemRow)
	    	{
				this.$router.push({ path: `${config.PUBLIC_PATH}giveaway-box/${itemRow.id}/edit` })
	    	},
	    	handleCandidates (itemRow)
	    	{
				this.$router.push({ path: `${config.PUBLIC_PATH}giveaway-box/${itemRow.id}/candidates` })
	    	},
	        handleDelete(itemRow)
	        {
	        	if (confirm(`Remove "${itemRow.slug}" ?`)) {
		    		axios.delete(`${this.apiUrl}/${itemRow.id}`)
			    		.then(function(response) {
			    			this.handlePageChange(this.data.page);
			    		}).catch(function (error) {
			    			alert('Could not remove item.');
						});
	        	}
	        },
	        handlePageChange(pageNum)
	        {
	            var apiUrl

	            this.loading = true

	            apiUrl = `${this.apiUrl}/${this.id}`
	            axios.get(apiUrl)
	            	.then((response) => {
	            		this.giveawayBox = response.data.data
	            	})

	            apiUrl = `${this.apiUrl}/${this.id}/candidatesByPage?limit=${this.pageSize}`

	            if (parseInt(pageNum, 10) > 1) {
	                apiUrl += `&page=${parseInt(pageNum, 10)}`
	            }

	            axios.get(apiUrl)
	                .then((response) => {
	                    this.data = response.data.data
	                    this.data.items = response.data.data.candidateList

	                    this.loading = false
	                });
	        },
		},
		watch: {
			'data.page' (to, from) {
				if (to !== from) {
					this.handlePageChange(to)
				}
			}
		},
		filters: {
			number: numberFormat
		}
	}
</script>